"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateTimePicker = exports.DateRangePicker = exports.DatePicker = void 0;
const bulma_calendar_1 = __importDefault(require("bulma-calendar"));
const mithril_1 = __importDefault(require("mithril"));
let _uid = 0;
const FR_LOCALIZATION = {
    lang: "fr",
    cancelLabel: "Annuler",
    clearLabel: "Vider",
    todayLabel: "Aujourd'hui",
    nowLabel: "Maintenant",
    validateLabel: "Valider"
};
function uid() { return _uid++; }
function PickerCreator(opts) {
    let calendar;
    let myUid = uid();
    opts = Object.assign({}, FR_LOCALIZATION, opts);
    return {
        oninit() {
        },
        oncreate(node) {
            let lastValue = undefined;
            let dom = node.dom.children[0];
            let calendars = bulma_calendar_1.default.attach(dom, opts);
            calendar = calendars[0];
            calendar.value(node.attrs.value);
            const fn = () => {
                const strdate = calendar.value();
                let evt = node.attrs.onchange;
                if (strdate !== lastValue && evt) {
                    lastValue = strdate;
                    evt.call(node, strdate);
                    mithril_1.default.redraw();
                }
            };
            calendar.on('clear', fn);
            calendar.on('select', fn);
        },
        onupdate(node) {
            let value = node.attrs.value;
            if (calendar) {
                let currValue = calendar.value();
                if (currValue !== value) {
                    calendar.value(node.attrs.value);
                    calendar.refresh();
                }
                ;
            }
        },
        view(vnode) {
            let type = opts.type || "date";
            let args = Object.assign({}, { type: type, id: `picker${myUid}` }, vnode.attrs);
            return (0, mithril_1.default)("span", (0, mithril_1.default)("input", args));
        }
    };
}
const DatePicker = () => {
    return PickerCreator({
        type: "date",
        showClearButton: false,
        dateFormat: "DD/MM/YYYY"
    });
};
exports.DatePicker = DatePicker;
const DateRangePicker = () => {
    return PickerCreator({
        type: "datetime",
        showClearButton: false,
        dateFormat: "DD/MM/YYYY",
        timeFormat: "HH:mm",
        color: "success",
        isRange: true,
    });
};
exports.DateRangePicker = DateRangePicker;
const DateTimePicker = (attr) => {
    attr = attr || {};
    return PickerCreator(Object.assign({
        type: "datetime",
        showClearButton: false,
        dateFormat: "DD/MM/YYYY",
        timeFormat: "HH:mm",
        color: "success"
    }, attr));
};
exports.DateTimePicker = DateTimePicker;
